module.exports = __webpack_public_path__ + "img/beneficio_inversion_2.2b310d16.webp";